/// <amd-module name="Agile/Sprints/Directory/Redux/SprintDirectoryActions" />
import { ITeam } from "Agile/Contracts/Common";
import { IBackcompatIteration } from "Agile/Sprints/Dialog/Contracts";
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const enum SprintDirectoryActionTypes {
    NewSprintOpened = "SprintDirectory/NewSprintOpened",
    NewSprintSucceeded = "SprintDirectory/NewSprintSucceeded",
    EditSprintOpened = "SprintDirectory/EditSprintOpened",
    EditSprintSucceeded = "SprintDiretory/EditSprintSucceeded",
    SprintPaneClosed = "SprintDirectory/SprintPaneClosed"
}

export const SprintDirectoryActions = {
    /** Action which opens the sprint pane for creation */
    newSprintOpened: () => createAction(SprintDirectoryActionTypes.NewSprintOpened),

    /**
     * Action which indicates when a sprint has been created
     * Navigates to the new sprint content
     */
    newSprintSucceeded: (team: ITeam, iteration: IBackcompatIteration) =>
        createAction(SprintDirectoryActionTypes.NewSprintSucceeded, {
            team,
            iteration
        }),

    /**
     * Action which opens the sprint pane for editing
     * @param team The team associated with the edited sprint
     * @param iterationId The id of the edited sprint
     */
    editSprintOpened: (team: ITeam, iterationId: string) =>
        createAction(SprintDirectoryActionTypes.EditSprintOpened, {
            team,
            iterationId
        }),

    /**
     * Action which indicates a sprint has been edited
     * @param team The team associated with the edited spring
     * @param iteration The updated iteration information
     */
    editSprintSucceeded: (team: ITeam, iteration: IBackcompatIteration) =>
        createAction(SprintDirectoryActionTypes.EditSprintSucceeded, {
            team,
            iteration
        }),

    /** Action which closes the sprint pane */
    sprintPaneClosed: () => createAction(SprintDirectoryActionTypes.SprintPaneClosed)
};

export type SprintDirectoryActions = ActionsUnion<typeof SprintDirectoryActions>;
